import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import RolePicker from './view/index.tsx';

export default ComponentWithAnalytics('RolePicker', {
	onChange: 'changed',
})(RolePicker);
